export const DEPARTMENT_OPTIONS = [
  "ICDS - DV",
  "ICDS - RTL",
  "ICDS - DFT",
  "ICDS - FPGA",
  "ICDS - Emulation",
  "ICDS - PD",
  "ICDS - FPV",
  "ICDS - AL",
  "Embedded - PCB",
  "Embedded - Hardware",
  "Embedded - Software",
  "Embedded - Automotive",
  "Embedded - Wireless",
];

export const JOB_DEPARTMENT_OPTIONS = ["ICDS", "Embedded"];
